import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { ROLE_NAME } from 'src/app/shared/enums/admin-enum';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { PATH_ROUTING } from 'src/app/shared/enums/routing-enums';
import { Paging, RequestOption } from 'src/app/shared/model/common.model';
import { ROLE } from '../create-edit-role/create-edit-role.component';
import { RoleService } from './../../../../../../shared/service/role.service';


@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.scss']
})
export class RoleComponent implements OnInit {

  displayedColumns = ['sso', 'full_Name', 'email', 'role', 'create_date', 'create_by', 'update_date', 'update_by', 'action'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  requestOption: RequestOption = new RequestOption();
  search = '';
  roles: any[] = [];
  role = '';
  sortTimeoutInstance: any;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    private spinner: Spinner,
    private toastr: ToastrService,
    private router: Router,
    private dialog: MatDialog,
    private roleService: RoleService
  ) { }

  ngOnInit() {
    this.roles = [...ROLE];
    this.roles.unshift({value: '', name: 'All'});
    this.loadDataTable();
  }

  public getListDataTable() {
    this.spinner.show();
    this.roleService.getData(this.requestOption, this.search, this.role).subscribe(res => {
      this.spinner.hide();
      if (res.data.content) {
        this.dataSource.data = res.data.content.map(item => {
          item.createdDate = new Date(item.createdDate).toLocaleString();
          item.updatedDate = new Date(item.updatedDate).toLocaleString();
          return item;
        });
        const rq: RequestOption = { ...this.requestOption };
        rq.pagingOptions.totalPages = res.data.totalPages;
        rq.pagingOptions.numberOfElements = res.data.numberOfElements;
        rq.pagingOptions.totalElements = res.data.totalElements;
        this.requestOption = rq;
      }
    });
  }

  public onChangeRequestOption(event: RequestOption) {
    this.requestOption = event;
    this.getListDataTable();
  }

  public initialRequestOption() {
    this.requestOption.pagingOptions.totalPages = 0;
    this.requestOption.pagingOptions.numberOfElements = 0;
  }

  public loadDataTable(goToFirstPage?: boolean) {
    if (goToFirstPage) {
      this.requestOption.pagingOptions = new Paging(this.requestOption.pagingOptions.size);
      this.initialRequestOption();
    }
    this.getListDataTable();
  }

  public searchData() {
    this.search = this.search.trim();
    this.requestOption.pagingOptions.number = 0;
    this.getListDataTable();
  }

  public addNewRole() {
    this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_ADD_ROLE]);
  }

  public edit(id) {
    this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'edit-role', id]);
  }

  public deleteUser(id) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_DELETE_ROLE
      }
    });
    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.spinner.show();
        this.roleService.deleteRole(id).subscribe((res: any) => {
          if (res.status === 200) {
            this.toastr.success(MESSAGE_TOAST.DELETE_ROLE);
            this.getListDataTable();
          }
        });
      }
    });
  }

  convertRoleToName(role) {
    return ROLE_NAME[role];
  }

  sortData(sort: Sort) {
    if (this.sortTimeoutInstance) {
      clearTimeout(this.sortTimeoutInstance);
    }
    this.sortTimeoutInstance = setTimeout(() => {
      this.requestOption.pagingOptions.sort.sortBy = sort.active;
      this.requestOption.pagingOptions.sort.sortOrder = sort.direction;
      this.getListDataTable();
    }, 500);
  }

}
